export abstract class BrowserStorageManager<DataType> {
  protected key: string;
  protected storage: Storage | undefined;

  constructor(key: string, storage: Storage) {
    this.key = key;
    this.storage = storage;
  }

  protected checkStorage(): boolean {
    return !!this.storage;
  }

  getItem(): DataType | undefined {
    if (!this.checkStorage()) return;
    try {
      const item = this.storage?.getItem(this.key);

      if (!item) return;

      return JSON.parse(item) as DataType;
    } catch (error) {
      console.error(error);
    }
  }

  setItem(item: DataType): void {
    if (!this.checkStorage()) return;
    try {
      if (item === undefined || item === null) throw new Error('Item cannot be null or undefined');

      this.storage?.setItem(this.key, JSON.stringify(item));
    } catch (error) {
      console.error(error);
    }
  }

  removeItem(): void {
    if (!this.checkStorage()) return;
    try {
      this.storage?.removeItem(this.key);
    } catch (error) {
      console.error(error);
    }
  }
}
